import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { BaseHttpService } from "@shared/services/base-http.service";

@Injectable({
  providedIn: "root"
})
export class BillingHttpService extends BaseHttpService {
  protected override baseEndpoint = "billing";

  createCheckoutSession(priceId: string): Observable<{ url: string }> {
    return this.post<{ url: string }>({
      endpoint: "create-checkout-session",
      body: { priceId }
    });
  }

  changePlan(planId: string): Observable<void> {
    return this.post<void>({
      endpoint: "change-plan",
      body: { planId }
    });
  }
}
